export default __webpack_public_path__ + "static/ebook-bg-8919d9a3ad8d27ab9bb0db0d31a92ed0.webp";